import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AppDialogService } from '@nimmsta/ng-commons-lib/services/app-dialog';
import { AppModelModalComponent } from '@nimmsta/ng-commons-lib/forms';
import { AuthorizationService } from '@nimmsta/ng-commons-lib/auth';
import { ContentsService } from '@nimmsta/ng-commons-lib/services/contents';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';
import { Workflow } from '@nimmsta/ng-commons-lib/models';
import { WorkflowService } from '@nimmsta/ng-commons-lib/services/workflow';
import { WorkflowFormComponent } from './workflow-form.component';
import { WorkflowDefinitionComponent } from './workflow-definition.component';

@Component({
  templateUrl: 'workflow-detail.component.html',
  imports: [
    TranslatePipe,
    WorkflowFormComponent,
    TranslatePipe,
    LoadingIndicatorComponent,
    HeaderBarComponent,
    ErrorComponent,
    AppModelModalComponent,
  ],
})
export class WorkflowDetailComponent implements OnInit {
  private authorizationService = inject(AuthorizationService);
  private workflowService = inject(WorkflowService);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private modalService = inject(AppDialogService);
  private contentsService = inject(ContentsService);

  error?: HttpErrorResponse;

  workflow?: Workflow;

  isLoading = false;

  fileUrl?: string;

  canWriteWorkflows = false;

  @ViewChild('EditModal', { static: true })
  private editModalComponent!: AppModelModalComponent<Workflow>;

  @ViewChild(WorkflowFormComponent, { static: true })
  private formComponent!: WorkflowFormComponent;

  ngOnInit(): void {
    this.canWriteWorkflows =
      this.authorizationService.hasPermission('workflow.write');
    this.loadWorkflow();
    this.formComponent.closeEvent.subscribe(() => {
      this.editModalComponent.hide();
    });
    if (this.workflow?.fileKey) {
      this.contentsService
        .getSignedUrl(this.workflow.fileKey)
        .subscribe((url) => {
          this.fileUrl = url;
        });
    }
  }

  loadWorkflow(): void {
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      this.workflowService.get(params['id']).subscribe({
        next: (workflow: Workflow) => {
          this.workflow = workflow;
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.isLoading = false;
        },
      });
    });
  }

  edit(): void {
    this.translate.get('user.edit').subscribe((value) => {
      this.openModal(value, true, this.workflow!);
    });
  }

  openModal(title: string, editable: boolean, value: Workflow): void {
    this.formComponent.editable = editable;
    this.formComponent.setValue(value);
    this.editModalComponent.title = title;
    this.editModalComponent.editable = editable;
    this.editModalComponent.show();
  }

  onSave(): void {
    this.formComponent.onSave();
  }

  getDefinitionString(): string {
    return JSON.stringify(this.workflow!.definition, null, 2);
  }

  showDefinition() {
    if (!this.canWriteWorkflows) {
      return;
    }
    const data = {
      workflow: this.workflow,
    };
    this.modalService.open(WorkflowDefinitionComponent, {
      data,
      size: 'xl',
      dismissableMask: false,
      closeOnEscape: false,
    });
  }
}
